<div class="container-fluid Business-professionalcontainer">
    <div class="row">
        <div class="col-md-5  col-xl-6 col-xs-12 padtop3 textCenter marbot110px ipadfullwidth">
            <div class="logo-section">
                <img class="rescue-shield" src="../../../assets/images/rescuemii-shield.png"
                    alt="RescueMII">
            </div>
            <h2 class="wlcmMsg">Welcome to RescueMII&trade;</h2>
            <div class="gps-leadsdiv">
                <div class="list-views">
                    <h2>YOUR <strong><span style="color: #f75a72;">DIGITAL BODYGUARD</span></strong></h2>
                    <p class="intro-copy">We are very excited to have you aboard, using some of the latest safety-technology ever
                        created. RescueMII&trade; is your Digital Bodyguard, offering seven distinct safety
                        features to help you in the event of a real crisis:</p>
                    <ul>
                        <li><strong>RescueMII&trade;</strong> is handsfree, voice-activated and simple TAP technology.</li>
                        <li><strong>RESCUE</strong> &ndash; when activated, calls your emergency
                            contacts within seconds.</li>
                        <li><strong>HELLO</strong> notifies someone you choose to tell your whereabouts, in the case
                            of an emergency.</li>
                        <li><strong>ALARM</strong> is a 90 decibel sounding police alarm, only deactivated by your
                            personal pin code.</li>
                        <li><strong>Capture</strong> delivers your photos, recordings and videos to your emergency
                            contacts instantly, just tap.</li>
                        <li><strong>TAP 911</strong>, Medical, Fire, and Police to connect instantly.</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-md-7 col-xl-6 col-xs-12 backgroundWhite marbot110px ipadfullwidth padtop3">
            <div class="card noBorder">
                <div class="card-body">
                    <!-- <div class="card-header-div">
                        <h4 class="card-title">Consumer Sign Up</h4>
                        <p class="already-account">Already have an account, <a (click)="login()">Sign In</a></p>
                    </div> -->
                    <!-- AC-4540: one column, fields labelled inside (placeholder) as in the
                         approved layout. Labels stay in the markup as sr-only for screen
                         readers. Every row uses col-12 so headings and inputs share the same
                         gutters - the old col-xs-12 is Bootstrap 3 and does nothing in 4.6,
                         which left the headings 15px out of line with the fields. -->
                    <!-- AC-4594: the app instead of the web form. A phone sees only its own store;
                         a desktop sees both. Android keeps the invite through the install (the
                         Play link's referrer); iOS can't, so it's told to tap the link again.
                         Each store's badge shows only once its listing is live, and the section
                         only when the visitor has a badge to tap. -->
                    <div class="row mb-4" *ngIf="(showAppStoreBadge && (isIOSDevice || !isMobileDevice)) || (showPlayStoreBadge && !isIOSDevice)">
                        <div class="col-12 text-center">
                            <h5 class="form-section-title">PREFER THE APP?</h5>
                            <p>
                                Download RescueMII&trade; and sign up there.
                                <span *ngIf="registrationCode && isIOSDevice">Once it's installed, tap your invitation link again.</span>
                                <span *ngIf="registrationCode && isMobileDevice && !isIOSDevice">Your invitation comes with you.</span>
                            </p>
                            <a *ngIf="showAppStoreBadge && (isIOSDevice || !isMobileDevice)" [href]="iOSStoreUrl" rel="noopener">
                                <img src="../../../assets/images/download-apple-store.png" alt="Download on the App Store"
                                    class="mx-1" height="45">
                            </a>
                            <a *ngIf="showPlayStoreBadge && !isIOSDevice" [href]="inviteAndroidStoreUrl" rel="noopener">
                                <img src="../../../assets/images/download-google-play.png" alt="Get it on Google Play"
                                    class="mx-1" height="45">
                            </a>
                            <p class="text-muted mt-3 mb-0">or enroll here on the web</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <h4 class="card-title enroll-title">ENROLL HERE</h4>
                        </div>
                    </div>
                    <form [formGroup]="consumerSignUpForm" class="enroll-form">
                        <div class="row">
                            <div class="col-12">
                                <h5 class="form-section-title">MEMBER INFORMATION</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="firstName" class="sr-only">First Name</label>
                                <input type="text" class="form-control" formControlName="firstName" id="firstName"
                                    placeholder="First Name" autocomplete="given-name"
                                    [ngClass]="{'is-invalid': submitted && form.firstName.errors}">
                                <div class="invalid-feedback" *ngIf="submitted && form.firstName.errors?.required">
                                    <span>Please enter First Name</span>
                                </div>
                            </div>
                            <div class="form-group col-12">
                                <label for="lastName" class="sr-only">Last Name</label>
                                <input type="text" class="form-control" formControlName="lastName" id="lastName"
                                    placeholder="Last Name" autocomplete="family-name"
                                    [ngClass]="{'is-invalid': submitted && form.lastName.errors}">
                                <div class="invalid-feedback" *ngIf="submitted && form.lastName.errors?.required">
                                    <span>Please enter Last Name</span>
                                </div>
                            </div>
                            <div class="form-group col-12">
                                <label for="phone" class="sr-only">Cell Number</label>
                                <input type="phone" class="form-control" formControlName="phone" id="phone"
                                    placeholder="Cell Number" autocomplete="tel"
                                    [ngClass]="{'is-invalid': (submitted || form.phone.dirty) && form.phone.errors}"
                                    maxlength="12">
                                <div class="invalid-feedback"
                                    *ngIf="(submitted || form.phone.dirty) && form.phone.errors">
                                    <span *ngIf="form.phone.errors.required">Please enter Cell Number</span>
                                    <span *ngIf="form.phone.errors.pattern">Please enter a valid Cell
                                        Number</span>
                                </div>
                            </div>
                            <div class="form-group col-12">
                                <label for="email" class="sr-only">Email Address</label>
                                <input type="email" class="form-control" formControlName="email" id="email"
                                    placeholder="Email Address" autocomplete="email"
                                    [ngClass]="{'is-invalid': (submitted || form.email.dirty) && form.email.errors}"
                                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                                    (change)="validateEmail($event)">
                                <div class="invalid-feedback"
                                    *ngIf="(submitted || form.email.dirty) && form.email.errors">
                                    <span *ngIf="form.email.errors.required">Please enter Email</span>
                                    <span *ngIf="form.email.errors.pattern">Please enter Valid Email</span>
                                </div>
                                <div class="invalid-feedback" *ngIf="displayEmailError">
                                    <p>{{errorMessage }}<span style="text-decoration: underline;
                                    color: black;cursor: pointer;" (click)="redirectToLogin()"> Sign In</span></p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <h5 class="form-section-title">CREATE A PASSWORD</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="password" class="sr-only">Password</label>
                                <input type="password" class="form-control" formControlName="password" id="password"
                                    placeholder="Password" autocomplete="new-password"
                                    [ngClass]="{'is-invalid': submitted && form.password.errors}">
                                <div class="invalid-feedback" *ngIf="submitted && form.password.errors">
                                    <span *ngIf="form.password.errors.required">Please enter Password</span>
                                    <span *ngIf="form.password.errors.minlength">Password must be atleast 8
                                        characters</span>
                                </div>
                            </div>
                            <div class="form-group col-12">
                                <label for="confirmPassword" class="sr-only">Confirm Password</label>
                                <input type="password" class="form-control" formControlName="confirmPassword"
                                    id="confirmPassword" placeholder="Confirm Password" autocomplete="new-password"
                                    [ngClass]="{'is-invalid': submitted && form.confirmPassword.errors}">
                                <div class="invalid-feedback" *ngIf="submitted && form.confirmPassword.errors">
                                    <span *ngIf="form.confirmPassword.errors.required">Please enter Confirm
                                        Password</span>
                                    <span *ngIf="form.confirmPassword.errors.mustMatch">Password Not Matching</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="registrationCode">
                                    Invitation Code<span *ngIf="!isInviteCodeReadOnly"> (Optional)</span>
                                </label>
                                <P style="color: #636363; margin: 0 0px 8px; line-height: 16px;">
                                    <ng-container *ngIf="isInviteCodeReadOnly">
                                        This is the code from your invitation. It connects you to the person who
                                        invited you, so it cannot be changed.
                                    </ng-container>
                                    <ng-container *ngIf="!isInviteCodeReadOnly">
                                        To connect with your agent, enter the invitation code that was sent to you in
                                        your text
                                    </ng-container>
                                </P>
                                <!-- Read-only, not disabled: a disabled control is dropped from
                                     the form value, and this code is what ties the signup back to
                                     the invite that was sent. -->
                                <input type="text" class="form-control" formControlName="registrationCode"
                                    id="registrationCode" placeholder="Enter 6 digit Invitation Code (Optional)"
                                    [readonly]="isInviteCodeReadOnly"
                                    [attr.aria-readonly]="isInviteCodeReadOnly ? 'true' : null"
                                    [ngClass]="{'is-invalid': submitted && form.registrationCode.errors,
                                                'readonly-field': isInviteCodeReadOnly}">
                                <p class="enroll-hint paid-invite-notice" *ngIf="isPaidInvite">
                                    This invitation includes the full RescueMII™ membership. After you create
                                    your account you can choose a plan, or continue with the free version.
                                    RESCUE, 911 and ALARM are always free.
                                </p>
                            </div>
                        </div>
                        <!-- AC-4441 emergency contacts. Rendered from emergencyContactSlots so
                             the slot count and the required count are declared once, in the
                             component, and match what the API and sprocs enforce. -->
                        <div class="row">
                            <div class="col-12">
                                <p class="enroll-hint">
                                    If you ever trigger RescueMII, these are the people we call and send your
                                    live location to. The first {{REQUIRED_EMERGENCY_CONTACTS}} are required; you
                                    can add up to {{TOTAL_EMERGENCY_CONTACTS}}.
                                </p>
                            </div>
                        </div>
                        <div class="row" *ngFor="let slot of requiredContactSlots">
                            <div class="col-12">
                                <h5 class="form-section-title">EMERGENCY CONTACT #{{slot.index}}</h5>
                            </div>
                            <div class="form-group col-12">
                                <label [attr.for]="slot.firstNameControl" class="sr-only">Emergency contact {{slot.index}} first name</label>
                                <input type="text" class="form-control" [formControlName]="slot.firstNameControl"
                                    [id]="slot.firstNameControl" placeholder="First Name"
                                    [ngClass]="{'is-invalid': submitted && form[slot.firstNameControl].errors}">
                                <div class="invalid-feedback"
                                    *ngIf="submitted && form[slot.firstNameControl].errors?.required">
                                    <span>Please enter First Name</span>
                                </div>
                            </div>
                            <div class="form-group col-12">
                                <label [attr.for]="slot.lastNameControl" class="sr-only">Emergency contact {{slot.index}} last name</label>
                                <input type="text" class="form-control" [formControlName]="slot.lastNameControl"
                                    [id]="slot.lastNameControl" placeholder="Last Name"
                                    [ngClass]="{'is-invalid': submitted && form[slot.lastNameControl].errors}">
                                <div class="invalid-feedback"
                                    *ngIf="submitted && form[slot.lastNameControl].errors?.required">
                                    <span>Please enter Last Name</span>
                                </div>
                            </div>
                            <div class="form-group col-12">
                                <label [attr.for]="slot.phoneControl" class="sr-only">Emergency contact {{slot.index}} cell number</label>
                                <input type="phone" class="form-control" [formControlName]="slot.phoneControl"
                                    [id]="slot.phoneControl" placeholder="Cell Number" maxlength="20"
                                    [ngClass]="{'is-invalid': submitted && form[slot.phoneControl].errors}">
                                <div class="invalid-feedback" *ngIf="submitted && form[slot.phoneControl].errors">
                                    <span *ngIf="form[slot.phoneControl].errors.required">Please enter Cell
                                        Number</span>
                                    <span *ngIf="form[slot.phoneControl].errors.pattern">Please enter a valid Cell
                                        Number</span>
                                </div>
                            </div>
                        </div>
                        <!-- Contacts 3-5 behind a toggle, same treatment as the agent and realtor
                             signup pages. onSubmit expands this if the blocking problem is inside
                             it, so a validation message cannot hide behind a collapsed panel. -->
                        <div class="veiwmorebtn">
                            <span class="viewMoreTxt" (click)="showOptionalContacts = !showOptionalContacts">
                                {{ showOptionalContacts ? 'Hide additional contacts' : 'Add more emergency contacts (Optional)' }}
                                <img
                                    [src]="showOptionalContacts ? '../../../assets/images/chevron-up.svg' : '../../../assets/images/chevron-down.svg'"
                                    alt="">
                            </span>
                        </div>
                        <div [style.display]="showOptionalContacts ? 'block' : 'none'">
                            <div class="row" *ngFor="let slot of optionalContactSlots">
                                <div class="col-12">
                                    <h5 class="form-section-title">EMERGENCY CONTACT #{{slot.index}} (OPTIONAL)</h5>
                                </div>
                                <div class="form-group col-12">
                                    <label [attr.for]="slot.firstNameControl" class="sr-only">Emergency contact {{slot.index}} first name (optional)</label>
                                    <input type="text" class="form-control" [formControlName]="slot.firstNameControl"
                                        [id]="slot.firstNameControl" placeholder="First Name">
                                </div>
                                <div class="form-group col-12">
                                    <label [attr.for]="slot.lastNameControl" class="sr-only">Emergency contact {{slot.index}} last name (optional)</label>
                                    <input type="text" class="form-control" [formControlName]="slot.lastNameControl"
                                        [id]="slot.lastNameControl" placeholder="Last Name">
                                </div>
                                <div class="form-group col-12">
                                    <label [attr.for]="slot.phoneControl" class="sr-only">Emergency contact {{slot.index}} cell number (optional)</label>
                                    <input type="phone" class="form-control" [formControlName]="slot.phoneControl"
                                        [id]="slot.phoneControl" placeholder="Cell Number" maxlength="20"
                                        [ngClass]="{'is-invalid': submitted && form[slot.phoneControl].errors}">
                                    <div class="invalid-feedback" *ngIf="submitted && form[slot.phoneControl].errors">
                                        <span *ngIf="form[slot.phoneControl].errors.pattern">Please enter a valid Cell
                                            Number</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="submitted && (consumerSignUpForm.errors?.duplicateEmergencyNumbers
                                || consumerSignUpForm.errors?.emergencyIsOwnNumber
                                || consumerSignUpForm.errors?.incompleteEmergencyContact)">
                            <div class="col-12">
                                <span class="formErrMsg" *ngIf="consumerSignUpForm.errors?.duplicateEmergencyNumbers">
                                    *Each emergency contact needs a different phone number</span>
                                <span class="formErrMsg" *ngIf="consumerSignUpForm.errors?.emergencyIsOwnNumber">
                                    *An emergency contact cannot be your own mobile number</span>
                                <span class="formErrMsg" *ngIf="consumerSignUpForm.errors?.incompleteEmergencyContact">
                                    *Every emergency contact needs both a name and a phone number</span>
                            </div>
                        </div>
                        <div class="flexDspl  agree-termarea">
                            <div class="custom-control custom-checkbox">
                                <input class="custom-control-input" type="checkbox" formControlName="agreeTandC"
                                    id="agreeTandCCheck">
                                <label class="custom-control-label" for="agreeTandCCheck">
                                    I Agree to all the
                                    <span class="tCtext" (click)="openTerms($event, 'TC')">Terms and
                                        Conditions</span>
                                    and
                                    <span class="tCtext" (click)="openTerms($event, 'PP')">Privacy Policy</span>
                                </label>
                            </div>
                        </div>
                        <span class="invalid-feedback" *ngIf="submitted && form.agreeTandC.errors">*Please accept the
                            Terms</span>
                        <div class="row">
                            <div class="col-12">
                                <button type="submit" class="btn submitButtonnew enroll-submit" (click)="onSubmit()">Create
                                    Account
                                </button>
                                <!-- <p class="already-account">Already have an account? <a (click)="login()">Sign In</a></p> -->
                                <span class="formErrMsg enroll-submit-error" *ngIf="submitted && consumerSignUpForm.invalid">*Enter All
                                    the
                                    Fields</span>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<button id="openRegSuccessBtn" [hidden]="true" data-toggle="modal" data-target="#regSuccess">RegSuccess</button>
<!-- Replica of the realtor signup success modal - same structure, same classes, same
     static backdrop. The copy and the download link are a consumer's next step: the app,
     not a web login. The store link is resolved from the device rather than shown as two
     badges, so a phone gets one tap straight to the right store. -->
<div class="modal fade" id="regSuccess" tabindex="-1" role="dialog" aria-labelledby="Registration Success"
    aria-hidden="true" data-backdrop="static" data-keyboard="false" #regSuccess>
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content confirmationModal">
            <div class="textCenter">
                <img src="../../../assets/images/pay_success.svg" alt="registration success" class="cnfrmImg">
            </div>
            <div class="martop20px cnfrmMsg">
                <strong>Welcome Aboard, you have successfully enrolled as a RescueMII&trade; Member.</strong>
            </div>
            <div class="martop20px text-center">
                TAP <a class="store-link" (click)="openStoreForDevice()">this link to download the RescueMII app
                    now</a>. Don't forget your username (email address) and password to log into
                RescueMII&trade;.<br />Stay safe! domii&reg;
            </div>
            <!-- A desktop user agent names no store, so rather than guessing at a platform that
                 cannot be inferred, both are offered explicitly. Hidden on a phone, where the tap
                 link above already resolves to the right one. -->
            <div class="martop20px text-center storeChoice" *ngIf="!isMobileDevice">
                <a class="store-link" (click)="openAppStore()">Apple App Store</a>
                <span class="storeChoiceSep">|</span>
                <a class="store-link" (click)="openPlayStore()">Google Play Store</a>
            </div>
        </div>
    </div>
</div>
<button id="openRegFailedBtn" [hidden]="true" data-toggle="modal" data-target="#regFailed">RegFailed</button>
<div class="modal fade" id="regFailed" tabindex="-1" role="dialog" aria-labelledby="Registration Failed"
    aria-hidden="true" #regFailed>
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content confirmationModal">
            <div class="textCenter">
                <img src="../../../assets/images/pay_failed.svg" alt="registration failed" class="cnfrmImg">
            </div>
            <div class="martop20px cnfrmMsg">
                <strong>Error Signing Up!</strong>
            </div>
            <!-- The API distinguishes an expired invite from an unusable set of emergency
                 contacts. Showing what it said is the difference between a fixable error
                 and a dead end. -->
            <div class="martop20px text-center" *ngIf="errorMessage">{{errorMessage}}</div>
        </div>
    </div>
</div>
<button id="openTermsConditionsBtn" [hidden]="true" data-toggle="modal" data-target="#termsConditions">T&C</button>
<div class="modal fade" id="termsConditions" tabindex="-1" role="dialog" aria-labelledby="Terms and Conditions"
    aria-hidden="true" #termsConditions>
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header col-xs-12 col-md-12 modalTitle">
                <div class="col-md-4 col-xs-4 padnull">
                    <img src="" alt="Logo" id="t&CLogo" class="tcLogo">
                </div>
                <span class="col-md-4 col-xs-4 textCenter">{{tcHeader}}</span>
                <div class="col-md-4 col-xs-4" style="text-align: end;">
                    <img src="../../../assets/images/cross.svg" data-toggle="modal" data-target="#termsConditions">
                </div>
            </div>
            <div class="modal-body">
                <iframe [src]="tcURL" class="tcIFrame"></iframe>
            </div>
        </div>
    </div>
</div>
<app-footer [rescueApp]="true"></app-footer>